import React, { Component } from 'react';
import { Plus } from './Plus';
import { Minus } from './Minus';
import './Disclosure.css';

export class Disclosure extends Component {
    constructor(props) {
        super(props);
        this.state = { open: false };
    }

    handleOnClick = () => {
        this.setState((state) => ({ open: !state.open }));
    };

    render() {
        return (
            <div className="DisclosureContainer">
                <section>
                    <button className="DisclosureButton" onClick={this.handleOnClick}>
                        {this.props.buttonText}
                        {this.state.open ? <Minus /> : <Plus />}
                    </button>
                </section>
                <article className="DisclosureContent" style={{ display: this.state.open ? 'block' : 'none' }}>
                    {this.props.content}
                </article>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Login/Disclosure.js